import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";

import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { ISinhVienUpdateDanhBaRequest } from "../../../model/request/sinh-vien/ISinhVienUpdateDanhBaRequest";
import {
  eDanhBaSinhVienActionIds,
  IDanhBaSinhVienActionTypes,
} from "../../action-types/category/IDanhBaSinhVienActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* danhBaSinhVienSaga(): any {
  yield takeLatest(eDanhBaSinhVienActionIds.LOAD_HOCSINH_START, loadWorker);
  yield takeEvery(eDanhBaSinhVienActionIds.SAVE_START, saveWorker);
}

function* loadWorker(action: IDanhBaSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienApi.SelectByLops,
    action.payload as ISinhVienSelectByLopsRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.category.danhBaSinhVien.LOAD_HOCSINH_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.category.danhBaSinhVien.LOAD_HOCSINH_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* saveWorker(action: IDanhBaSinhVienActionTypes): any {
  const payload = action.payload as ISinhVienUpdateDanhBaRequest;
  const res: IBaseRespone = yield call(sinhVienApi.UpdateDanhBa, payload);
  if (res?.is_success) {
    yield put(rootActions.category.danhBaSinhVien.SAVE_SUCCESS(payload));
  } else {
    yield put(
      rootActions.category.danhBaSinhVien.SAVE_ERROR(res?.message ?? "Có lỗi"),
    );
  }
}
